
/* ========================================================================
//	SOLUTION
======================================================================== */

(function ($) {

	
    $('.sliderCases').slick({
        infinite: false,
        slidesToShow: 3,
        dots: true,
        prevArrow: false,
        nextArrow: false,
		speed: 500,
		cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
		autoplay: false,
		// autoplaySpeed: 10000,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 568,
				settings: {
					slidesToShow: 1
				}
			}
		]
    })
	
    MyTools.initPg('SOLUCAO');
    
})(jQuery, MyTools);